import React from 'react';

import classNames from 'classnames';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import ClearButton from './ClearButton';
import css from './filters.module.sass';

const RoleSelect = (props) => {
  const { onFilter, value: selectedId, label, alias, options } = props;

  const handleSelection = (event) => {
    const { value } = event.target;
    onFilter(alias, value);
  };

  if (!options?.length) return null;

  return (
    <FormControl variant="outlined" className={classNames(css.wrapper, props.className)}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedId || ''}
        onChange={handleSelection}
        label={label}
        endAdornment={selectedId && <ClearButton withMargin onClick={() => onFilter(alias, null)} />}
        className={selectedId && css.active}
      >
        {options.map((option, i) => (
          <MenuItem key={`option_${i}`} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RoleSelect;
